import { Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import '../GiftCardEdit.scss';

export const MessageFormItem = () => (
  <div className="input-row">
    <Form.Item
      name="message"
      label="Message"
      rules={[{ required: true, message: 'Required' }]}
    >
      <TextArea maxLength={250} />
    </Form.Item>
  </div>
);
